module.exports = __webpack_public_path__ + "static/TERMOS_DE_USO-_VALE_-_Encontro_de_Especialistas-489dddc11317b8b7bbddb4a6d602c10d.pdf";